<template>
  <v-layout row wrap>
    <v-flex xs12 md4 pr-4>
      <v-text-field
        label="School Type"
        v-model="education.SchoolType"
        readonly
      ></v-text-field>      
    </v-flex>
    <v-flex xs12 md8>
      <v-text-field v-model="education.SchoolName" label="School Name:" :readonly="disableFields"></v-text-field>
    </v-flex>
    <v-flex xs12 md3 pr-4>
      <v-text-field  v-model="education.Degree"  label="Degree:" :readonly="disableFields"></v-text-field>
    </v-flex>
    <v-flex xs12 md3 pr-4>
      <date-picker
        label="Date"
        v-model="education.Date"
        :disabled="disableFields"
      ></date-picker>
    </v-flex>
    <v-flex xs12 md3 pr-4>
      <v-text-field v-model="education.City" label="City:" :readonly="disableFields" ></v-text-field>
    </v-flex>
    <v-flex xs12 md3>
      <v-text-field v-model="education.State" label="State:" :readonly="disableFields" ></v-text-field>
    </v-flex>
  </v-layout>
</template>

<script>
import Rules from '../../validation/rules'
import DatePickerVue from '../DatePicker.vue';
export default {
  props: {
    education: Object,
    disableFields: Boolean
  },
  data(){
    return {
      menu: false,
      rules:Rules
    }
  },
  watch:{
    education: {
      handler(val){
        this.$emit('input', val)
      },
      deep: true
    }
  },
  components: {
    'date-picker' : DatePickerVue
  }
}
</script>

<style>

</style>
